import type { ReactNode } from 'react';

/**
 * DIN-caps section heading with a 1px rule to the right and an optional right slot
 * (count or cutoff timestamp). Tone 'signal' tints the heading and rule orange.
 */
export function SectionRuleHeader({
  label,
  right,
  tone = 'default',
}: {
  label: string;
  right?: ReactNode;
  tone?: 'default' | 'signal';
}) {
  const labelCls = tone === 'signal' ? 'text-signal' : 'text-ink-muted';
  const ruleCls = tone === 'signal' ? 'bg-signal/30' : 'bg-line';
  return (
    <div className="mb-3 flex items-center gap-3">
      <h2 className={`shrink-0 font-display text-2xs font-bold uppercase tracking-[0.08em] ${labelCls}`}>
        {label}
      </h2>
      <div className={`h-px flex-1 ${ruleCls}`} />
      {right !== undefined && (
        <span className={`font-mono text-2xs tabular-nums ${labelCls}`}>{right}</span>
      )}
    </div>
  );
}
